import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/invoice_history/
export const invoiceHistory = async () => {
  // const response = await new Request().get('/ajax/invoice_headers/invoice_history')
  const response = await new Request().get('/ajax/invoice_history')
  return Util.Obj.keysToCamel(response.data)
}
